import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Grid, Col, Button, Glyphicon } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import Logger from '../stores/Logger'

class Goodbye extends Component {
    render() {
        Logger.trackEvent('goodbye')

        return (
            <Grid>
                <Col xs={10} xsOffset={1} md={4} mdOffset={4}>
                    <div style={{display:'flex',justifyContent:'center'}}>
                        <img src='/PreDo-logo.png' alt='PRE.DO' style={{width:'300px',height:'168px'}}/>
                    </div>
                    <div style={{textAlign:"center"}}>
                        <h1>Goodbye</h1>
                        <div>We hope you come back and innovate with us again soon!</div>
                        <h1><Glyphicon glyph='hand-down'/></h1>
                        <LinkContainer to='/login'>
                            <Button bsStyle='primary'>Login to PRE.DO</Button>
                        </LinkContainer>
                    </div>
                </Col>
            </Grid>
        )
    }
}

export default inject("stores")(observer(Goodbye))



// WEBPACK FOOTER //
// ./src/containers/Goodbye.js